import React from 'react';
import FastImage from 'react-native-fast-image';

import Theme from '../../../theme';

export const GloveIcon = ({
  color = Theme.WHITE,
  width,
  height,
}) => (
    <FastImage
      resizeMode='contain'
      style={{
        width,
        height,
      }}
      source={require('../../../assets/images/glove.png')}
    />
  );
